import { WarehouseWorkerDetails } from "api/wms/models";
import { InfoLabel } from "components/common/infoLabel";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import { RightPanelSection } from "components/utils/drawer";

interface Props {
  warehouseWorker: WarehouseWorkerDetails;
}

export const GeneralInfoSection = ({ warehouseWorker }: Props) => {
  return (
    <RightPanelSection>
      <Typography fontSize="26" fontWeight="700">
        {warehouseWorker.firstName} {warehouseWorker.lastName}
      </Typography>
      <InfoLabel title="e-mail">
        <Typography fontSize="14" fontWeight="700">
          {warehouseWorker.email}
        </Typography>
      </InfoLabel>
    </RightPanelSection>
  );
};
